import React, { useEffect, useState, useRef } from "react";
import $ from "jquery";
import axios from "axios";
import { Link, useOutletContext } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { currency_converter_inr } from "../../utils/currencyUtils";
import CountUp from "react-countup";
import AddClient from "../client/add_client";
import { openInAppTab } from "../../utils/tabNavigation";

function Client() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const navigate = useNavigate();

  const [clientStatus, SetclientStatus] = useState([]);
  const [bd, Setdb] = useState([]);
  const [industries, Setindustries] = useState([]);
  const [countries, Setcountries] = useState([]);
  const [financialyear, Setfinancialyear] = useState([]);
  const [options, setoptions] = useState([]);
  const [fy, setfy] = useState(null);
  const [ffy, setffy] = useState();
  const [optionsLoaded, setOptionsLoaded] = useState(false);
  const [total_clients, settotal_clients] = useState(null);
  const [active_clients, setactive_clients] = useState(null);
  const [inactive_clients, setinactive_clients] = useState(null);
  const [new_clients, setnew_clients] = useState(null);
  const [addClientModal, setAddClientModal] = useState(false);

  const columns = [
    {
      accessorKey: "company_name",
      header: "Company Name",
      size: 300,
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 3,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 1,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      Cell: ({ row }) => {
        return (
          <div className="d-flex align-items-center file-name-icon">
            <a
              href={`/client/view/${row.original.client_id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${row.original.client_id}`); }}
              className="avatar avatar-md border rounded-circle"
              target="_blank"
            >
              <img
                src={
                  row.original.logo
                    ? `${PINE_BASE_URL}/files/companyLogo/${row.original.logo}`
                    : `${PINE_BASE_URL}/files/companyLogo/nologo.png`
                }
                className="img-fluid"
                alt="logo"
                style={{ width: "40px", height: "40px", objectFit: "contain" }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = `${PINE_BASE_URL}/files/companyLogo/nologo.png`;
                }}
              />
            </a>
            <div className="ms-2">
              <h6 className="fw-medium mb-0">
                <Link
                  to={`/client/view/${row.original.client_id}`}
                >
                  {row.original.company_name}
                </Link>
              </h6>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "ageing",
      header: "Ageing",
      size: 100,
    },
    {
      accessorKey: "parent_group",
      header: "Parent Group",
    },
    {
      accessorKey: "client_status",
      header: "Status",
      size: 100,
    },
    {
      accessorKey: "bd_by",
      header: "Business Developed",
    },
    {
      accessorKey: "client_managed_by",
      header: "Client Managed",
    },
    {
      accessorKey: "industryMaster",
      header: "Sector",
      size: 100,
    },
    {
      accessorKey: "industryMinor",
      header: "Sub Sector",
      size: 100,
    },
    {
      accessorKey: "current_revenue",
      header: `Revenue ${ffy ? ffy : fy}`,
      size: 100,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "current_received",
      header: `Received ${ffy ? ffy : fy}`,
      size: 100,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "total_revenue",
      header: `LifeTime Revenue ${ffy ? ffy : fy}`,
      size: 300,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "private_equity",
      header: "PE",
      size: 100,
      accessorFn: (row) => row.private_equity === "yes" ? "Private Equity" : "-",
      Cell: ({ cell }) => cell.getValue(),
    },
    {
      accessorKey: "gcc",
      header: "GCC",
      size: 50,
      accessorFn: (row) => row.gcc === "yes" ? "GCC" : "-",
      Cell: ({ cell }) => cell.getValue(),
    },
    {
      accessorKey: "active_roles",
      header: "Active Roles",
      size: 70,
    },
    {
      accessorKey: "averageFee",
      header: "Average Fee",
      size: 100,
      Cell: (info) =>
        info.cell.getValue() != null ? info.cell.getValue() + "%" : "NA",
    },
    {
      accessorKey: "averageVOBT",
      header: "Avg Vobt",
      size: 100,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "arpa",
      header: "ARPA",
      size: 100,
      Cell: (info) => currency_converter_inr(info.cell.getValue() ?? 0),
    },
    {
      accessorKey: "hasClientLogin",
      header: "Client Portal",
      size: 100,
    },
    {
      accessorKey: "region_name",
      header: "Origin",
      size: 100,
    },
    {
      accessorKey: "country_name",
      header: "Country",
      size: 100,
    },
  ];

  async function fetchOptions() {
    setGlobalLoading(true); //  Show loader before API call
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/get_client_list/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setoptions(response.data.client || []);
      setOptionsLoaded(true);
      console.log(response.data);
      settotal_clients(response.data.total_clients[0].total_clients);
      setactive_clients(response.data.active_clients[0].active_clients);
      setinactive_clients(response.data.inactive_clients[0].total_inactive);
      setnew_clients(response.data.new_clients[0].new_client);
    } catch (error) {
      console.error("API Error:", error);
      setoptions([]); // Prevent errors from breaking UI
      setOptionsLoaded(true);
    }
  }

  useEffect(() => {
    fetchOptions();

    setfy(fyf());
  }, []);

  useEffect(() => {
    if (options.length > 0 || optionsLoaded) {
      setGlobalLoading(false);
    }
  }, [options]);

  const financial_year = async () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth is 0-based

    const endYear = currentMonth < 4 ? currentYear - 1 : currentYear;
    const year = [];
    for (let startYear = 2018; startYear <= endYear; startYear++) {
      year.push(`${startYear}-${startYear + 1}`);
    }

    return year;
  };

  const fyf = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // getMonth is 0-based
    const shortYear = currentYear % 100;

    const year =
      currentMonth < 4
        ? `${shortYear - 1}-${shortYear}`
        : `${shortYear}-${shortYear + 1}`;
    return year;
  };

  useEffect(() => {
    async function get_filter_dropdowns() {
      try {
        const [client_status, business_developed, industry, country] =
          await Promise.all([
            axios.get(`${API_BASE_URL}/common_controller/get_client_status`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }),
            axios.get(
              `${API_BASE_URL}/common_controller/get_business_developed/`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            ),
            axios.get(
              `${API_BASE_URL}/common_controller/get_master_industry_list/`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            ),
            axios.get(`${API_BASE_URL}/common_controller/get_countries_list/`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }),
          ]);
        SetclientStatus(client_status.data.options);
        Setdb(business_developed.data.options);
        Setindustries(industry.data.options);
        Setcountries(country.data.options);

        const $country_select = $("select[name='countries']");
        setTimeout(() => {
          $country_select.select2({
            placeholder: "Select Country",
          });
        }, 100);

        $country_select.on("change", function (e) {
          const selectedValues = $(this).val();
          setValue("countries", selectedValues || []);
        });
        return () => {
          $country_select.select2("destroy");
        };
      } catch (error) {
        console.log(error);
      } finally {
      }
    }

    async function init() {
      await get_filter_dropdowns();

      const years = await financial_year(); // <-- FIXED: Await the async call
      Setfinancialyear(years);
    }

    init();
  }, []);

  const filterform = async (data) => {
    setGlobalLoading(true);
    console.log(data);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/get_client_filtered_list/`,
        {
          formData: data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setoptions(response.data.client || []);
      setffy(response.data.fy);
      setOptionsLoaded(true);
    } catch (error) {
      console.log(error);
      alert(error.response.data.error);
      window.location.reload();
      setOptionsLoaded(true);
    }
  };

  const handleReset = async () => {
    reset();
    await fetchOptions(); // stop loading when done
  };

  const financial_year_change = async (e) => {
    let year = e.target.value;
    if (year != "") {
      $("[name='client_status']").attr("disabled", true);
      $("[name='gka']").attr("disabled", true);
    } else {
      $("[name='client_status']").attr("disabled", false);
      $("[name='gka']").attr("disabled", false);
    }
  };

  const data = [];
  const check_client_status_or_new_old = async (e) => {
    let value = e.target.value;
    if (value != "") {
      data.push(value);
      $("[name='financial_year']").attr("disabled", true);
    } else {
      data.pop(value);
    }
    if (data.length <= 0) {
      $("[name='financial_year']").attr("disabled", false);
    }
  };

  useEffect(() => {
    $('[name="client_search"]').select2({
      multiple: false,
      closeOnSelect: true,
      ajax: {
        type: "POST",
        url: `${API_BASE_URL}/clients/companyLoad`,
        dataType: "json",
        contentType: "application/json",
        delay: 250, // Delay for better UX
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", `Bearer ${token}`);
        },
        data: function (params) {
          console.log(
            "Sending JSON:",
            JSON.stringify({ keywords: params.term }),
          ); // Debugging
          return JSON.stringify({ keywords: params.term }); // ✅ Send JSON payload
        },
        processResults: function (data) {
          console.log(data.options);
          if (!data.options || data.options.length === 0) {
            return {
              results: [],
            };
          }
          return {
            results: data.options.map((item, index) => ({
              id: item.value, // ✅ Add prefix to the ID
              value: item.value,
              text: item.label,
            })),
          };
        },
        cache: true,
      },
      placeholder: "Search Client",
      allowClear: true,
      minimumInputLength: 1,
      tags: false,
      language: {
        noResults: function () {
          return "No client found"; // Ensure "No results found" is displayed
        },
      },
      escapeMarkup: function (markup) {
        return markup;
      },
    });

    $("[name='client_search']").on("change", function () {
      const selectedValues = $(this).val() || [];
      navigate(`/client/view/${selectedValues}`);
    });

    return () => {
      $("[name='client_search']").off("change"); // Cleanup on unmount
    };
  }, [token, API_BASE_URL, setValue]);

  // const handleExport = (table) => {
  //   const visibleColumns = table.getVisibleLeafColumns();
  //   const visibleRows = table.getRowModel().rows;
  //   exportExcel({ table, columns: visibleColumns, rows: visibleRows });
  // };

  async function fetchClientsByType(type) {
    setGlobalLoading(true); // show loader
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clients/get_clients_by_type`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { type }, // pass 'inactive', 'active', or 'new'
        },
      );

      setoptions(response.data.clients || []); // update table data
      setOptionsLoaded(true);
    } catch (error) {
      console.error("Error fetching clients:", error);
      setoptions([]);
      setOptionsLoaded(true);
    } finally {
      setGlobalLoading(false); // hide loader
    }
  }

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Clients</h2>
          </div>
        </div>
        {addClientModal && (
          <AddClient onClose={() => setAddClientModal(false)} />
        )}

        <div className="row" style={{ marginTop: "-20px" }}>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setAddClientModal(true)}
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-user-plus fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <a
                        href="javascript:void(0);"
                        className="text-secondary fw-semibold me-2 d-inline-block"
                        onClick={() => setAddClientModal(true)}
                      >
                        Create New Client
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/contract/list")
            }
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-file-contract fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/contract/list"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Contracts
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/client/clientrisk")
            }
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-fire fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/client/clientrisk"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Client at Risk
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate("/client/revenuerisk")
            }
            className="col-xl-3 col-md-6"
          >
            <div className="card border-0">
              <div className="alert alert-default border border-default mb-0 p-3">
                <div className="d-flex align-items-start">
                  <div className="text-primary w-100">
                    <div className="fw-semibold text-center">
                      <i className="fa-solid fa-money-bills fs-35"></i>
                    </div>
                    <div className="fs-12 text-center">
                      <Link
                        to={"/client/revenuerisk"}
                        className="text-secondary fw-semibold me-2 d-inline-block"
                      >
                        Revenue at Risk
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className="card flex-fill"
              style={{ cursor: "pointer" }}
              onClick={() => fetchClientsByType("all")} // fetch all clients
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-primary-transparent border border-primary d-flex align-items-center justify-content-center">
                        <i className="ti ti-users fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        All Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={total_clients ? total_clients : 0}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className="card flex-fill"
              style={{ cursor: "pointer" }} // shows pointer on hover
              onClick={() => fetchClientsByType("active")} // call your filter function with "active"
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-share fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Active Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={active_clients ? active_clients : 0}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className="card flex-fill"
              style={{ cursor: "pointer" }}
              onClick={() => fetchClientsByType("inactive")}
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-pause fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        Inactive Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={inactive_clients ? inactive_clients : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 d-flex">
            <div
              className="card flex-fill"
              style={{ cursor: "pointer" }}
              onClick={() => fetchClientsByType("new")}
            >
              <div className="card-body my-card-body">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-2">
                      <span className="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center">
                        <i className="ti ti-user-plus fs-18"></i>
                      </span>
                    </div>
                    <div>
                      <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                        New Clients
                      </p>
                      <h4 className="counter">
                        <CountUp
                          start={0}
                          end={new_clients ? new_clients : "0"}
                          duration={3}
                        />
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginBottom: "10px" }}>
          <div
            className="accordion accordion-secondary"
            id="accordionSecondaryExample"
          >
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSecondaryOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSecondaryOne"
                  aria-expanded="false"
                  aria-controls="collapseSecondaryOne"
                >
                  Use filters to find specific set of clients:
                </button>
              </h2>
              <div
                id="collapseSecondaryOne"
                className="accordion-collapse collapse"
                aria-labelledby="headingSecondaryOne"
                data-bs-parent="#accordionSecondaryExample"
              >
                <div className="accordion-body">
                  <form onSubmit={handleSubmit(filterform)}>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Client Type:
                            <span className="text-danger">
                              *{" "}
                              {errors.client_type && errors.client_type.message}
                            </span>
                          </label>
                          <select
                            {...register("client_type")}
                            className="form-select"
                          >
                            <option key={0} value={""}>
                              Select Client Type
                            </option>
                            <option key={1} value={2}>
                              Contingent
                            </option>
                            <option key={2} value={3}>
                              Retained
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Client Status:
                            <span className="text-danger">
                              *{" "}
                              {errors.client_status &&
                                errors.client_status.message}
                            </span>
                          </label>
                          <select
                            {...register("client_status")}
                            onChange={check_client_status_or_new_old}
                            className="form-select"
                          >
                            <option value={""}>Select Client Status</option>
                            {clientStatus.length > 0
                              ? clientStatus.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">New/Old:</label>
                          <select
                            {...register("gka")}
                            className="form-select"
                            onChange={check_client_status_or_new_old}
                          >
                            <option key={0} value={""}>
                              Select Option
                            </option>
                            <option key={1} value={"new"}>
                              New
                            </option>
                            <option key={2} value={"old"}>
                              Old
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">
                            Business Developed:
                          </label>
                          <select {...register("bd")} className="form-select">
                            <option value={""}>Select BD</option>
                            {bd.length > 0
                              ? bd.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Sector:</label>
                          <select
                            {...register("industry")}
                            className="form-select"
                          >
                            <option value={""}>Select Sector</option>
                            {industries.length > 0
                              ? industries.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Financial Year:</label>
                          <select
                            {...register("financial_year")}
                            className="form-select"
                            onChange={financial_year_change}
                          >
                            <option value={""}>Select Financial Year</option>
                            {financialyear.length > 0
                              ? financialyear.map((item, index) => (
                                  <option key={index} value={item}>
                                    {item}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label">Country:</label>
                          <select
                            className="form-select"
                            {...register("countries")}
                            multiple
                          >
                            {countries.length > 0
                              ? countries.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.label}
                                  </option>
                                ))
                              : ""}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                      <div className="mb-3">
                        <label className="form-label">
                          Client Category:
                        </label>
                        <select {...register("client_category")} className="form-select">
                          <option value="">Select Client Category</option>
                          <option value="private_equity">Private Equity</option>
                          <option value="gcc">GCC</option>
                        </select>
                      </div>
                    </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <button type="submit" className="btn btn-primary">
                          Search with filter(s)
                        </button>
                      </div>
                      <div
                        className="col-md-3 md-offset-6"
                        style={{ marginLeft: "-65px" }}
                      >
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => {
                            setGlobalLoading(true);
                            handleReset();
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center flex-wrap row-gap-3">
            <h5>Quick Search:</h5>
            <div className="col-md-9" style={{ marginLeft: "10px" }}>
              <div className="input-icon-end position-relative remove-icon">
                <select
                  style={{ width: "100%" }}
                  {...register("client_search", {
                    required: false,
                  })}
                  id="select-client"
                ></select>
              </div>
            </div>
            <div className="me-2 ms-5">
              <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                <a
                  onClick={() => navigate("/client/list")}
                  className="btn btn-icon btn-sm active bg-primary text-white"
                >
                  <i className="ti ti-list-tree"></i>
                </a>
                <a
                  onClick={() => navigate("/client/grid")}
                  className="btn btn-icon btn-sm me-1"
                >
                  <i className="ti ti-layout-grid"></i>
                </a>
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={options}
                initialState={{
                  pagination: { pageSize: 200 },
                }}
                muiTableBodyRowProps={{
                  sx: {
                    height: "20px", // compact row height
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Client;
